import AppClaimStatusBean from "../data/bean/app_claim_status_bean";
import BaseWebService from "../service/base_web_service";
import GeneralWebService from "../service/general_web_service";
import AppTableStatus from "../ui/component/app_table_status/app_table_status";
import AuthBloc from "./auth_bloc";
import SubmittedDocumentBean from "../data/bean/submitted_document_bean";
import UserAccessBloc from "./user_access_bloc";
import { Image } from "antd";
import UtilBloc from "./util_bloc";
import { globalState } from "../data/global/globalState";
import Config from "../Config";
import App_card_status from "../ui/component/app_card_status/app_card_status";
import DropDownActionListing from "../ui/component/app_dropdwon_action/app_dropdown_action";
import Labels from "../ui/constant/labels";
import DropDownContactAction from "../ui/component/app_dropdwon_action/app_dropdown_contact_action";
import moment from "moment";
import AppViewAction from "../ui/component/app_view_action/app_view_action";
import ImageAction from "../ui/component/app_dropdwon_action/app_image_action";
import DropDownSearchAction from "../ui/component/app_dropdwon_action/app_dropdown_search_action";
import LanguageBloc from "./language_bloc";
import jsonData from "../../src/service/sample/jsonData.json";
import DataResult from "../data/bean/data_result";
import {Skeleton, Switch} from "antd";
import DropDownAdminAction from "../ui/component/app_dropdwon_action/app_dropdown_admin_action";

class GeneralBloc {
  static getIdentificationEntityDesc() {
    return <ol className="w-100">
      <li>
        This is a declaration form provided by an entity to a financial institution for the purpose of automatic exchange of financial account information. The data collected may be transmitted to the Inland Revenue Board of Malaysia for transfer to the tax authority of another jurisdiction
      </li>
      <li>
        Any changes with regards to the details provided in this form must be informed to Prudential Assurance Malaysia Berhad
      </li>
      <li>
        All questions are mandatory.
      </li>
      <li>
        <span style={{ color: "white", fontWeight: "bold" }}>"Controlling Person"</span> is a natural person(s) who ultimately has a controlling ownership interest (typically on the basis of a certain percentage(e.g. 25%) in the Entity). Where no natural person(s) exercises control through ownership interests, the Controlling Person(s) of the Entity will be the natural person(s) who exercises control of the Entity through other means. Where no natural person or persons are identified as exercising control of the Entity through ownership interests, the Controlling Person of the Entity is deemed to be the natural person who holds the position of senior managing official.
      </li>
      <li>
        "Account Holder" refers to the policy owner of the above-mentioned policy or policy to be issued pursuant to the above-mentioned proposal.
      </li>
      <li>
        Further information on tax residence may be found on the OECD website on <a href="http://www.oecd.org/tax/automatic-exchange/" target="_blank" rel="noopener"><span className="white-link">http://www.oecd.org/tax/automatic-exchange/</span></a> or please seek appropriate tax advice.
      </li>
    </ol>
  }

  static getDocFataDesc() {
    return <ol className="w-100">
      <li>
        Financial institution refers to any organization that holds a banking, securities, and/or life insurance
        license. Examples of financial institutions include banks, life insurers, custodians, asset managers,
        and investment funds.
      </li>
      <li>
        Professionally managed trust is a trust that is professionally managed by a bank, custodial institution,
        insurance company or an investment entity that is an investment advisor.
      </li>
      <li>
        United States Person / United States Entity defined as one of the following:
        <ol>
          <li>Citizen or resident of the United States of America</li>
          <li>A partnership, corporation, company, or association created or organised in the United States of America or under the laws of the United States of America</li>
          <li>Any estate in the United States of America</li>
          <li>Any trust that is under the supervision of the United States of America and substantially controlled by any United States of America person.</li>
        </ol>
      </li>

    </ol>
  }

  //getErrorInvalidDevice desciption
  static getErrorInvalidDevice() {
    return LanguageBloc.getTextByCode(Labels.ERROR_INVALID_DEVICE)
  }

  static getCurrentRole() {
    let role = AuthBloc.getRoleDetails();
    return role;
  }

  //onValidateValues
  static onValidateValues(fields, values) {
    let allIsEmpty = true;
    this.fields().map((field) => {
      allIsEmpty = allIsEmpty && UtilBloc.isNullOrEmpty(this.values()[field]);
    });
    return allIsEmpty;
  }

  static LBL_STEP_PROPOSAL = "LBL_STEP_PROPOSAL";
  static LBL_STEP_DECLARATION = "LBL_STEP_DECLARATION";
  static LBL_STEP_SIGNATURE = "LBL_STEP_SIGNATURE";

  //fnCalculateAgeFromGivesDates
  static fnCalculateAgeFromGivesDates(endDateInput) {
    var startDateInput = moment(new Date()).format("MM/DD/YYYY"); //mm/dd/yyyy     	 
    // convert user input values into date object
    var startDate = new Date(startDateInput);
    var endDate = new Date(endDateInput);

    // get difference between two date;
    var difference = endDate - startDate.getTime();

    var ageDate = new Date(difference);
    var calculatedAge = Math.abs(ageDate.getUTCFullYear() - 1970);
    return calculatedAge
  }

  static convertDobFormat(dob) {
    if (null == dob) {
      return dob
    } else {
      var parts = dob.split('/');
      var formattedDate = parts[2] + '-' + parts[1] + '-' + parts[0];
      return formattedDate;
    }
  }

  static anbChecking(pid, dob) {
    // Convert the date strings to Date objects
    const pidDate = new Date(pid);
    const dobDate = new Date(dob);

    // Extract the day, month, and year from the dates
    const pidDay = pidDate.getDate();
    const pidMonth = pidDate.getMonth();
    const pidYear = pidDate.getFullYear();

    const dobDay = dobDate.getDate();
    const dobMonth = dobDate.getMonth();
    const dobYear = dobDate.getFullYear();

    // Calculate month*31 + day for both dates
    const pidValue = (pidMonth * 31) + pidDay;
    const dobValue = (dobMonth * 31) + dobDay;

    // Determine Age Next Birthday (ANB)
    let anb;

    if (pidValue === dobValue) {
      anb = pidYear - dobYear;
    } else if (pidValue > dobValue) {
      anb = pidYear - dobYear + 1;
    } else {
      anb = pidYear - dobYear;
    }

    return anb;
  }

  //getClientViewSteps for Customer Flow
  static getClientViewSteps() {
    return [
      {
        label: "LBL_REVIEW",
        icon: ["category_active_mobile", "category_non_active_mobile"],
      },
      {
        label: "LBL_STEP_DECLARATION_AND_SIGN",
        icon: ["signature_active_mobile", "signature_non_active_mobile"],
      },
      {
        label: "LBL_STEP_CONFIRMATION",
        icon: ["confirmation_active_mobile", "confirmation_non_active_mobile"],
      },
    ];
  }

  //getAgentViewSteps for Quotation
  static getAgentViewSteps() {

    return [
      {
        label: "LBL_PERSONAL_DETAILS",
      },
      {
        label: "LBL_PRODUCT_DETAILS",
      },
      {
        label: "LBL_PREVIEW_SUBMIT",
      },
    ];
  }

  //getAgentViewProposalSteps for Proposal
  static getAgentViewProposalSteps() {
    return [
      {
        label: "Details",
      },
      {
        label: Labels.LBL_HEALTH_QUESTIONNARIES,
      },
      {
        label: Labels.LBL_STEP_DECLARATION,
      },
      {
        label: Labels.LBL_UPLOAD_DOCUMENTS,
      },
      {
        label: "Preview",
      },

    ];
  }

  //getFieldsOtp id
  static getFieldsOtp() {
    return [
      "number_1",
      "number_2",
      "number_3",
      "number_4",
      "number_5",
      "number_6",
    ];
  }

  //No used
  static getDashboardModule() {
    return [
      {
        caption: "Overall Dashboard",
        value: "Overall Dashboard",
      },
      {
        caption: "Upcoming Events",
        value: "Upcoming Events",
      },
    ];
  }

  //No used
  static getShortDashboardModule(part) {
    let newPath = "";
    if (part == "Overall Dashboard") {
      newPath = "dashboard";
    } else if (part == "Upcoming Events") {
      newPath = "event";
    }
    return newPath;
  }

  //No used
  static getSwitchUpcomingOrDashboard(route, part) {
    let newRoute = "";
    if (part == "Overall Dashboard") {
      if (route == Config.routes.generic.certificateCollectionUpcoming) {
        newRoute = Config.routes.generic.certificateCollection;
      }

      if (route == Config.routes.generic.businessOpportunityUpcoming) {
        newRoute = Config.routes.generic.businessOpportunity;
      }
    } else if (part == "Upcoming Events") {
      if (route == Config.routes.generic.certificateCollection) {
        newRoute = Config.routes.generic.certificateCollectionUpcoming;
      }

      if (route == Config.routes.generic.businessOpportunity) {
        newRoute = Config.routes.generic.businessOpportunityUpcoming;
      }
    }
    return newRoute;
  }

  //No used
  static getModuleDetailsFromUserSetting(userSettings, module) {
    return userSettings.module[module];
  }

  //encodeAndDecodeURL
  static encodeAndDecodeURL(url) {
    let encoded = encodeURIComponent(url);
    let decoded = decodeURIComponent(encoded);
    return decoded;
  }

  //formatDate following dd/mm/yyyy
  static formatDate(date) {
    var dd = String(date.getDate()).padStart(2, "0");
    var mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = date.getFullYear();

    return dd + "/" + mm + "/" + yyyy;
  }

  //Get url to image by image code
  static getImageURLByCode(code) {
    return BaseWebService.baseUrl() + "/asset/image/" + code;
  }

  static getAssetsContextPath() {
    return "/myCUEPACSCare";
  }

  //getDateRangeFilter
  static async getDateRangeFilter(id) {
    let token = "";
    const session = await AuthBloc.checkSession();

    if (session) {
      token = session.accessToken;
    }
    let response = await GeneralWebService.getDateRangeFilter(token, id);
    return response;
  }

  //no used
  static async getDateRangeUpcomingFilter(id) {
    let token = "";
    const session = await AuthBloc.checkSession();

    if (session) {
      token = session.accessToken;
    }
    let response = await GeneralWebService.getDateRangeUpcomingFilter(
      token,
      id
    );
    return response;
  }

  //no used
  static async getSearchBys(id) {
    let token = "";
    const session = await AuthBloc.checkSession();

    if (session) {
      token = session.accessToken;
    }
    let response = await GeneralWebService.getSearchBys(token, id);
    return response;
  }

  //no used
  static resultColumnToObject(result) {
    let resultColumn = result;

    let mappedData = [];
    for (var i = 0; i < resultColumn.length; i++) {
      let record = resultColumn[i];
      let columnKey = record.key;
      for (var j = 0; j < record.list.length; j++) {
        let recordValue = record.list[j];
        if (i == 0) {
          mappedData.push({});
        }
        mappedData[j][columnKey] = recordValue;
      }
    }
    return mappedData;
  }

  //no used
  static async getDetailContent(response, module) { }

  //no used
  static async getListingTable(response, module, userConfigCache) {
    let data = [];
    let collumnTable = [];
    let totalData = 0;
    let recCount = response.data.recCount;
    totalData = recCount;

    let userConfig = await UserAccessBloc.getUserConfigForModule(
      null,
      null,
      module,
      userConfigCache
    );
    let listSetting = userConfig.list;
    let fieldStyle;
    let fieldIcon;
    let fieldAlign;
    if (listSetting) {
      fieldStyle = listSetting.fieldStyle;
      fieldIcon = listSetting.fieldIcon;
      fieldAlign = listSetting.fieldAlign;
    }
    for (let i = 0; i < response.data.resultColumns[0].list.length; i++) {
      let record = {};

      for (let j = 0; j < response.data.resultColumns.length; j++) {
        let key = response.data.resultColumns[j]["key"];
        let value = response.data.resultColumns[j]["list"][i];
        if (value == null) {
          value = "N/A";
        }
        if (fieldStyle && fieldStyle[key]) {
          let keyFieldStyle = fieldStyle[key];
          let styleSet = false;
          for (var x = 0; x < (keyFieldStyle || []).length; x++) {
            let curKeyStyleValue = keyFieldStyle[x].value;

            if (curKeyStyleValue == value) {
              let curKeyStyleTranslation = keyFieldStyle[x].translation;
              styleSet = true;
              record[key] = (
                <AppTableStatus
                  statusName={curKeyStyleTranslation || value}
                  textColor={keyFieldStyle[x].textColor}
                  background={keyFieldStyle[x].background}
                />
              );
            }
          }
          if (!styleSet) {
            record[key] = value;
          }
        } else if (fieldIcon && fieldIcon[key]) {
          let keyFieldIcon = fieldIcon[key];
          let iconSet = false;
          for (var x = 0; x < (keyFieldIcon || []).length; x++) {
            let curKeyIconValue = keyFieldIcon[x].value;
            if (curKeyIconValue == value) {
              iconSet = true;
              record[key] = (
                <img
                  id={value}
                  src={GeneralBloc.getImagePath(keyFieldIcon[x].icon)}
                  height={20}
                  width={20}
                />
              );
            }
          }
          if (!iconSet) {
            record[key] = value;
          }
        } else {
          record[key] = value;
        }
      }
      data.push(record);
    }
    for (let x = 0; x < response.data.resultColumns.length; x++) {
      let displayFlex = response.data.resultColumns[x]["displayFlex"];
      if (displayFlex === 0) {
        continue;
      }
      let recordCollumn = {};

      let ObjectOfKeyFieldAlign = {};
      let indexOfMatchedCollumn = 0;

      if (fieldAlign) {
        ObjectOfKeyFieldAlign = Object.keys(fieldAlign);
        indexOfMatchedCollumn = ObjectOfKeyFieldAlign.indexOf(
          response.data.resultColumns[x].key
        );
      }

      if (
        response.data.resultColumns[x].key ==
        ObjectOfKeyFieldAlign[indexOfMatchedCollumn]
      ) {
        recordCollumn = {
          title: response.data.resultColumns[x].caption,
          dataIndex: response.data.resultColumns[x].key,
          responsive: ["md"],
          align: fieldAlign[ObjectOfKeyFieldAlign[indexOfMatchedCollumn]],
          // sorts by seq
        };
      } else {
        recordCollumn = {
          title: response.data.resultColumns[x].caption,
          dataIndex: response.data.resultColumns[x].key,
          responsive: ["md"],
          // sorts by seq
        };
      }

      collumnTable.push(recordCollumn);
    }
    return {
      columnTable: collumnTable,
      data: data,
      total: totalData,
    };
  }

  //viewOrDownloadFile by document id
  static async viewOrDownloadFile(id, view) {
    let result = await UtilBloc.downloadFile("form", id);
    if (result.success) {
      let filename = `${id}.${"pdf"}`;
      UtilBloc.downloadBinary(result.data.data, filename);
    }
  }

  //no use
  static async getModuleCounts(module, byPassPage, criParams) {
    let token = "";
    const session = await AuthBloc.checkSession();
    // console.log(session);

    if (session) {
      token = session.accessToken;
    }

    let userSession = await AuthBloc.checkSession();
    let bankId = userSession.roles[0].entity;
    let roleCode = userSession.roles[0].mapCode;

    let response = await GeneralWebService.getModuleCount(
      module,
      token,
      bankId,
      criParams,
      byPassPage
    );

    let result = response.data;
    let countData = {};
    let resultColumn = null;
    if (result) {
      resultColumn = result.resultColumns;
      let mappedData = this.resultColumnToObject(resultColumn);
      for (var i = 0; i < mappedData.length; i++) {
        let map = mappedData[i];
        countData[map["pCertStatus"]] = map["figure"];
      }
    }
    return countData;
  }

  //getFilteredByDate
  static getFilteredByDate(dateFilter, fromDate, toDate) {
    let d = new Date();
    let beginDate = "";
    let endDate = "";

    switch (dateFilter) {
      case "":
        let date1 = new Date();
        date1.setDate(date1.getDate() + 1);
        endDate = date1.toISOString().slice(0, 10);
        beginDate = "1900-01-01";
        break;
      case "-30d":
        endDate = d.toISOString().split("T")[0];
        d.setDate(d.getDate() - 30);
        beginDate = d.toISOString().split("T")[0];
        break;
      case "-60d":
        endDate = d.toISOString().split("T")[0];
        d.setDate(d.getDate() - 60);
        beginDate = d.toISOString().split("T")[0];
        break;
      case "-90d":
        endDate = d.toISOString().split("T")[0];
        d.setDate(d.getDate() - 90);
        beginDate = d.toISOString().split("T")[0];
        break;
      case "range":
        beginDate = fromDate;
        endDate = toDate;
        break;
      default:
        break
    }

    endDate = `${endDate} 23:59:59`;
    beginDate = `${beginDate} 00:00:00`;
    let result = { beginDate: beginDate, endDate: endDate };
    return result;
  }

  //getFilteredByDateCACAndSuper
  static getFilteredByDateCACAndSuper(dateFilter, fromDate, toDate) {
    let d = new Date();
    let beginDate = "";
    let endDate = "";

    switch (dateFilter) {
      case "":
        var date = new Date();
        // add a day
        date.setDate(date.getDate() + 1);
        endDate = date.toISOString().slice(0, 10);
        beginDate = "1900-01-01";
        break;
      case "-30d":
        endDate = d.toISOString().split("T")[0];
        d.setDate(d.getDate() - 30);
        beginDate = d.toISOString().split("T")[0];
        break;
      case "-60d":
        endDate = d.toISOString().split("T")[0];
        d.setDate(d.getDate() - 60);
        beginDate = d.toISOString().split("T")[0];
        break;
      case "-90d":
        endDate = d.toISOString().split("T")[0];
        d.setDate(d.getDate() - 90);
        beginDate = d.toISOString().split("T")[0];
        break;
      case "range":
        beginDate = fromDate;
        endDate = toDate;
        break;
      default:
        break;
    }
    endDate = `${endDate}`;
    let result = { beginDate: beginDate, endDate: endDate };
    return result;
  }


  static getSubmittedDocuments(list) {
    let newList = [];
    /*  "id":"NBUGroup2@@2198@@63417",
         "docClass":"NBUGroup2",
         "docId":"NBU-NAPP-02",
         "category":"Proposal Documents",
         "subCategory":"Proposal Form",
         "nric":"900909123457",
         "applicationNum":"0054480002",
         "certNum":"BL004558",
         "receivedDate":"2022-08-11",
         "boxId":"",
         "claimNum":"",
         "otherId":"900909123457" */
    if (list) {
      list.map((ev) => {
        newList.push(
          new SubmittedDocumentBean(ev.id, ev.subCategory, null, "pdf", true)
        );
      });
    }

    return newList;
  }

  //no use
  static async checkAccessModule(module, userConfigCache) {
    let moduleSetting = await UserAccessBloc.getUserConfigForModule(
      null,
      null,
      module,
      userConfigCache
    );
    let check = true;
    if (UtilBloc.isNullOrEmpty(moduleSetting)) {
      check = false;
    }
    return check;
  }

  //no use
  static getResultColumnByKey(key, resultColumn) {
    if (!resultColumn || resultColumn.length <= 0) return null;
    let filtered = resultColumn.filter((it) => it.key == key);

    if (filtered.length <= 0) return null;
    return filtered[0];
  }

  //no use
  static async getStatusBox(
    module,
    moduleId,
    showForEmpty,
    byPassPage,
    criParams,
    userConfigGlobal
  ) {
    let moduleSetting = await UserAccessBloc.getUserConfigForModule(
      null,
      null,
      module,
      userConfigGlobal
    );
    let boxes = [];
    if (moduleSetting) {
      let statuses = moduleSetting.status || [];
      let counts = await this.getModuleCounts(moduleId, byPassPage, criParams);
      for (var i = 0; i < statuses.length; i++) {
        let status = statuses[i];
        let mapCode = status.mapCode;
        let count = counts[mapCode] || 0;
        if (count > 0 || showForEmpty == true) {
          boxes.push(
            new AppClaimStatusBean(
              status.icon,
              status.inactiveIcon,
              status.name,
              count,
              status.code,
              status.background,
              status.translation
            )
          );
        }
      }
    }
    return boxes;
  }

  //no use
  static async getDynamicFilter(endpoint, request) {
    let token = "";
    const session = await AuthBloc.checkSession();
    if (session) {
      token = session.accessToken;
    }

    let response = await GeneralWebService.getDynamicFilter(
      token,
      endpoint,
      request
    );
    return response;
  }

  //no use
  static async getBranchesList(regions) {
    let token = "";
    const session = await AuthBloc.checkSession();
    if (session) {
      token = session.accessToken;
    }

    let response = await GeneralWebService.getBranchList(token, regions);
    let data = [];
    if (response.success) {
      for (let i = 0; i < response.data.resultColumns[0].list.length; i++) {
        let record = {};

        let key = response.data.resultColumns[0]["list"][i];
        let value = response.data.resultColumns[1]["list"][i];
        record = {
          code: key,
          name: value,
          status: true,
        };
        data.push(record);
      }
    }
    return data;
  }

  //no use
  static async getSearchCriteriaList(regions, id) {
    let token = "";
    const session = await AuthBloc.checkSession();
    if (session) {
      token = session.accessToken;
    }

    let response = await GeneralWebService.getSearchCriteriaList(
      token,
      regions,
      id
    );

    let data = [];
    if (response.success) {
      // let record = {};
      for (let i = 0; i < response.data.resultColumns[0].list.length; i++) {
        let record = {};
        for (let j = 0; j < response.data.resultColumns.length; j++) {
          record[response.data.resultColumns[j]["key"]] =
            response.data.resultColumns[j]["list"][i];

          record.status = false;
        }
        data.push(record);
      }
    }
    return data;
  }

  //no use
  static async getAgentLists(regions, branches) {
    let token = "";
    const session = await AuthBloc.checkSession();
    if (session) {
      token = session.accessToken;
    }

    let response = await GeneralWebService.getAgentList(
      token,
      regions,
      branches
    );

    let data = [];
    if (response.success) {
      for (let i = 0; i < response.data.length; i++) {
        let record = {};
        record = {
          code: response.data[i].id,
          name: response.data[i].name,
          status: true,
        };
        data.push(record);
      }
    }
    return data;
  }

  //no use
  static getRegionSelectionsFromUserInfo(userInfo) {
    let regions = [];
    for (let i = 0; i < userInfo.roles.length; i++) {
      let userRole = userInfo.roles[i];
      let record = {};
      record = {
        code: userRole.region,
        name: userRole.regionName,
        status: false,
      };
      regions.push(record);
    }
    return regions;
  }

  //no use
  static getRegionsFromUserInfo(userInfo) {
    let regions = [];
    for (let i = 0; i < userInfo.roles.length; i++) {
      let userRole = userInfo.roles[i];
      regions.push(userRole.region);
    }
    return regions;
  }

  //no use
  static async getDateRangeFromConfig(userConfig, module) {
    let dateRangeSetting =
      (await UserAccessBloc.getUserDateRangeForModule(
        null,
        null,
        module,
        userConfig
      )) || {};
    let options = dateRangeSetting.options || [];
    let captions = [];
    let codes = [];
    for (var i = 0; i < options.length; i++) {
      let opt = options[i];
      let caption = opt.title;
      let code = opt.code;
      captions.push(caption);
      codes.push(code);
    }

    return {
      captions: captions,
      codes: codes,
      default: dateRangeSetting.default,
      defaultPlaceholder: dateRangeSetting.defaultPlaceholder,
    };
  }

  //Get 2 first letter of agent name for avatar
  static mergeIntoInitialName(name) {
    let stringArray = name.split(" ");
    let first = stringArray[0] ? stringArray[0].charAt(0) : "";
    let last = stringArray[stringArray.length - 1]
      ? stringArray[stringArray.length - 1].charAt(0)
      : "";
    return [first, last];
  }

  //getListingData
  static getListingData(response, module) {
    let data = {};
    let totalData = 0;
    let recCount = response?.page?.total || 0;
    let pageCount = response?.page?.pageCount || 0;
    let limitData = response?.page?.limit || 0;
    let curretnPage = response?.page?.page || 0;
    let collumns = [];

    totalData = recCount;
    if (response) {
      data = response.data;
    }

    //collumns = Config[module]?.dataTableCollumnMapping || [];    
    collumns = this.getJsonContent()[module].dataTableCollumnMapping;
    if(module=="file_upload"){
      collumns=[
        {
          "title": "File Name",
          "key": "fileName",
          "dataIndex": "fileName",
          "width": 200
        },
        {
          "title": "Uploaded On",
          "key": "updatedOn",
          "dataIndex": "updatedOn",
          "width": 200,         
        },
        {
          "title": "Uploaded By",
          "key": "updatedBy",
          "dataIndex": "updatedBy",
          "width": 200
        },
        {
          "title": "Success Rate",
          "key": "successRate",
          "dataIndex": "successRate",
          "width": 200
        },
        {
          "title": "Status",
          "key": "status",
          "dataIndex": "status",
          "width": 200
        },
        {
          "title": "Action",
          "key": "action",
          "dataIndex": "action",
          "fixed": "right",
          "width": 100
        }
      ] 
    } 
    
    if(module=="agent_management" ){
      collumns=[
        {
          "title": "Agent ID",
          "key": "agentID",
          "dataIndex": "agentID",
          "width": 200
        },
        {
          "title": "Agent Name",
          "key": "agentName",
          "dataIndex": "agentName",
          "width": 200,
          "sorter": (a, b) => a.agentName.localeCompare(b.agentName),
          "sortDirections": ['ascend', 'descend']
        },
        {
          "title": "Agent Code",
          "key": "agentCode",
          "dataIndex": "agentCode",
          "width": 200
        },
        {
          "title": "Role",
          "key": "role",
          "dataIndex": "role",
          "width": 200,
          "sorter": (a, b) => a.role.localeCompare(b.role),
          "sortDirections": ['ascend', 'descend']
        },
        {
          "title": "Segment",
          "key": "segment",
          "dataIndex": "segment",
          "width": 200
        },
        {
          "title": "Updated On",
          "key": "lastUpdate",
          "dataIndex": "lastUpdate",
          "width": 200,
          "sorter": (a, b) => a.lastUpdate.localeCompare(b.lastUpdate),
            "sortDirections": ['ascend', 'descend']
        },
        {
          "title": "PRUConnect Access",
          "key": "access",
          "dataIndex": "access",
          "width": 300,
          "sorter": (a, b) => a.access.localeCompare(b.access),
            "sortDirections": ['ascend', 'descend']
        },
        {
          "title": "Action",
          "key": "action",
          "dataIndex": "action",
          "fixed": "right",
          "width": 100
        }
      ] 
    }
    return {
      data: data,
      dataCollumn: collumns,
      totalData: totalData,
      pageCount: pageCount,
      limitData: limitData,
      curretnPage: curretnPage,
    };
  }

  static getListingCountData(response) {
    let data = {};

    data = response.data;

    return {
      data: data,
    };
  }

  //getListingTableRow
  static getListingTableRow(data, module, entity, typeAction, role) {
    let result = [];
    //Add in here
    //console.log("MODULEHERE",module)
    data.forEach((item, index) => {
      //console.log("ITEMMM",item)      
      let record = {};
      if (module === "quotation") {
        let proposalTrxStatus = item && item.proposal && item.proposal.trxStatus ? item?.proposal?.trxStatus : "";
        record = {
          key: index + 1,
          refNo: item?.[module]?.refNo ?? "-",
          proposalRefNo: item?.proposal?.refNo ?? "-",
          proposalNo: item?.proposal?.proposalNo ?? "-",
          fullName: (item?.client?.name || item?.quotation_attr?.properties?.name) ?? "-",
          createdOn: UtilBloc.formatDateFollowingFormat(item?.[module]?.createdOn, "DD/MM/YYYY HH:mm:ss") ?? "-",
          updatedOn: UtilBloc.formatDateFollowingFormat(item?.[module]?.updatedOn, "DD/MM/YYYY HH:mm:ss") ?? "-",
          company: (item?.quotation?.company) ?? "-",
          trxStatus: item?.[module]?.trxStatus ? (
            <App_card_status status={item?.[module].trxStatus ?? ""} module={module} />
          ) : (
            <App_card_status status={"UNDEFINED"} module={module} />
          ),
          action: (
            proposalTrxStatus ?
              <DropDownActionListing
                status={item?.proposal?.trxStatus ?? ""}
                module={module}
                subModule={"proposal"}
                allowedToDelete={item?.[module]?.allowedToDelete ?? false}
                allowedToUpdate={true}
                id={item?.proposal?.id ?? ""}
                quotationId={item?.quotation?.id ?? ""}
                proposalId={item?.proposal?.id ?? ""}
                refresh={() => window.location.reload()}
              />
              :
              <DropDownActionListing
                status={item?.[module]?.trxStatus ?? ""}
                module={module}
                allowedToDelete={item?.[module]?.allowedToDelete ?? false}
                allowedToUpdate={item?.[module]?.allowedToUpdate ?? false}
                clientId={item?.quotation_attr?.properties?.clientId}
                proposalId={item?.proposal?.id ?? ""}
                quotationId={item?.quotation?.id ?? ""}
                id={item?.quotation?.id ?? ""}
                refresh={() => window.location.reload()}
              />
          ),
        };
      } else if (entity === "checker_approval_list") {
        let proposal = item?.proposal ?? {};
        let userProfile = item?.user_profile?.properties ?? {};
        let supervisorName = "";
        let supervisorActionDate = "";
        let cacName = "";
        let cacActionDate = "";

        if ((typeAction === "search" || typeAction === "processed" || typeAction === "pending" || typeAction === "processing") && role === "cac") {
          supervisorName = proposal?.supervisor_approval_name;
          supervisorActionDate = proposal?.supervisor_approval_date ? UtilBloc.formatDateFollowingFormat(proposal?.supervisor_approval_date?.split(" ")[0], "DD/MM/YYYY") : "-";
          cacName = proposal?.cac_approval_name;
          cacActionDate = proposal?.cac_approval_date ? UtilBloc.formatDateFollowingFormat(proposal?.cac_approval_date?.split(" ")[0], "DD/MM/YYYY") : "-";
        }

        if ((typeAction === "search") && role === "supervisor") {
          supervisorName = proposal?.supervisor_approval_name;
          supervisorActionDate = proposal?.supervisor_approval_date ? UtilBloc.formatDateFollowingFormat(proposal?.supervisor_approval_date?.split(" ")[0], "DD/MM/YYYY") : "-";
          cacName = proposal?.cac_approval_name;
          cacActionDate = proposal?.cac_approval_date ? UtilBloc.formatDateFollowingFormat(proposal?.cac_approval_date?.split(" ")[0], "DD/MM/YYYY") : "-";
        }
        record = {
          key: index + 1,
          proposalNo: proposal?.proposalNo ?? "-",
          customerName: (item?.client?.name || item?.proposal_attr?.properties?.customerName) ?? "-",
          company: item?.quotation?.company ?? "-",
          salesRepresentativeName: userProfile?.name ?? "-",
          salesRepresentativeID: proposal?.createdBy ?? "-",
          branchname: userProfile?.branch ?? "-",
          planName: proposal?.planName ?? "-",
          salesRepresentativeSubmissionDate: UtilBloc.formatDateFollowingFormat(proposal?.submissionDate?.split(" ")[0], "DD/MM/YYYY") ?? "-",
          submissionExpiryDate: UtilBloc.formatDateFollowingFormat(proposal?.expiryDate?.split(" ")[0], "DD/MM/YYYY") ?? "-",
          supervisorName: supervisorName || "-",
          supervisorActionDate: supervisorActionDate || "-",
          cacName: cacName || "-",
          cacActionDate: cacActionDate || "-",
          trxStatus: proposal?.trxStatus ?
            <App_card_status status={proposal?.trxStatus} module={"checker_approval_list"} />
            : (
              <App_card_status status={"UNDEFINED"} module={"checker_approval_list"} />
            ),
          action: (
            typeAction === "search" ?
              <DropDownSearchAction
                supervisorName={supervisorName || ""}
                supervisorActionDate={supervisorActionDate || ""}
                cacName={cacName || ""}
                cacActionDate={cacActionDate || ""}
                role={role}
                status={proposal?.trxStatus ?? null}
                module={entity}
                entity={entity}
                id={proposal?.id ?? ""}
                quotationId={proposal?.quotationId ?? ""}
                agentId={proposal?.createdBy ?? null}
                action={typeAction}
                refresh={() => window.location.reload()}
              />
              :
              <DropDownActionListing
                supervisorName={supervisorName || ""}
                supervisorActionDate={supervisorActionDate || ""}
                cacName={cacName || ""}
                cacActionDate={cacActionDate || ""}
                role={role}
                status={proposal?.trxStatus ?? null}
                module={entity}
                entity={entity}
                id={proposal?.id ?? ""}
                quotationId={proposal?.quotationId ?? ""}
                agentId={proposal?.createdBy ?? null}
                action={typeAction}
                refresh={() => window.location.reload()}
              />
          ),
        };
      } else if (module === "proposal") {
        record = {
          key: index + 1,
          refNo: item?.[module]?.refNo ?? "-",
          proposalNo: item?.[module]?.proposalNo ?? "-",
          fullName: item?.client?.name || item?.proposal_attr?.properties?.name || "-",
          idNo: item?.[module]?.idNumber || item?.proposal_attr?.properties?.idNo || "-",
          createdOn: UtilBloc.formatDateFollowingFormat(item?.[module]?.createdOn, "DD/MM/YYYY HH:mm:ss") ?? "-",
          updatedOn: UtilBloc.formatDateFollowingFormat(item?.[module]?.updatedOn, "DD/MM/YYYY HH:mm:ss") ?? "-",
          company: item?.quotation?.company ?? "-",
          trxStatus: item?.[module]?.trxStatus ? (
            <App_card_status status={item[module].trxStatus} module={module} />
          ) : (
            <App_card_status status={"UNDEFINED"} module={module} />
          ),
          action: (
            <DropDownActionListing
              status={item?.[module]?.trxStatus ?? ""}
              module={module}
              allowedToDelete={item?.[module]?.allowedToDelete ?? false}
              allowedToUpdate={item?.[module]?.allowedToUpdate ?? false}
              id={item?.proposal?.id ?? ""}
              quotationId={item?.quotation?.id ?? ""}
              proposalId={item?.proposal?.id ?? ""}
              refresh={() => window.location.reload()}
            />
          ),
        };
      } else if (module === "agent_management") {   
        let segment=item?.subChannel;
        if(segment=="MS"){
          segment="Mortgage"
        }
  
        if(segment=="BB"){
          segment="Business Banking"
        }
  
        if(segment=="CBD"){
          segment="Commercial Banking"
        }             
        record = {
          key: index + 1,
          agentID: item?.userId ?? "-",
          agentName:item?.agentName ?? "-",
          agentCode: item?.agentCode ?? "-",
          role: item?.roleGroup=="CAC" ? "CAC/WLOC" : item?.roleGroup ?? "-",
          segment: segment ?? "-",
          lastUpdate: UtilBloc.formatDateFollowingFormat(item?.adminUpdatedOn || item?.createdOn, "DD/MM/YYYY HH:mm:ss") ?? "-",
          access: item?.status
            || "-",
          action: (
            <DropDownAdminAction
              status={"DRAFT"}
              module={module}              
              id={item?.userId ?? ""}
              refresh={() => window.location.reload()}
            />
          ),
        };
      } else if (module === "file_upload") { 
        let status=item?.uploadStatus;        
        if(status=="PARTIAL_SUCCESS"){
          status="Partially Successful"
        }
  
        if(status=="FAILED"){
          status="Failed"
        }
  
        if(status=="SUCCESS"){
          status="Successful"
        }   
        record = {
          key: index + 1,
          fileName: item?.fileName ?? "-",
          updatedOn: UtilBloc.formatDateFollowingFormat(item?.updatedOn || item?.createdOn, "DD/MM/YYYY HH:mm:ss") ?? "-",
          updatedBy: (item?.updatedBy || item?.createdBy) ?? "-",
          successRate: item?.successCount+"/"+item?.totalCount ?? "-",          
          status: status ?? "-",         
          action: (
            <DropDownAdminAction
              status={item?.uploadStatus}
              module={module}              
              id={item?.id ?? ""}
              refresh={() => window.location.reload()}
            />
          ),
        };
      }
      else {                
        record = {
          key: index + 1,
          name: item?.name ?? "-",
          idNo: item?.idNo ?? "-",
          otherIdNo: item?.otherIdNo ?? "-",
          dob: moment(item?.dob).format("DD-MM-YYYY").replaceAll("-", "/")=="Invalid date" ? item?.dob?.replaceAll("-", "/") : moment(item?.dob).format("DD-MM-YYYY").replaceAll("-", "/") ?? "-",
          //dob: item?.dob?.replaceAll("-", "/") ?? "-",
          email: item?.email ?? "-",
          company: item?.company ?? "-",
          lastTransaction: item?.updatedOn ? UtilBloc.formatDateFollowingFormat(item?.updatedOn, "DD/MM/YYYY HH:mm:ss") : UtilBloc.formatDateFollowingFormat(item?.createdOn, "DD/MM/YYYY HH:mm:ss"),
          quotationCount: item?.quotationCount ?? "0",
          proposalCount: item?.proposalCount ?? "0",
          action: (
            <DropDownContactAction
              status={"DRAFT"}
              module={"contact"}
              allowedToDelete={item?.allowedToDelete ?? false}
              allowedToUpdate={item?.allowedToUpdate ?? false}
              quotationIds={item?.quotationIds ?? []}
              proposalIds={item?.proposalIds ?? []}
              id={item?.id ?? ""}
              refresh={() => window.location.reload()}
            />
          ),
        };
      }
      result.push(record);
    });
    return result;
  }


  //getDateRangeDropdownFilter
  static getDateRangeDropdownFilter() {
    let response = {
      default: "",
      caption: [
        "All Time",
        "Last 30 Days",
        "Last 60 Days",
        "Last 90 Days",
        "Custom",
      ],
      value: ["", "-30d", "-60d", "-90d", "range"],
    };

    return response;
  }

  //getSortFilters
  static getSortFilters() {
    return {
      default: "newest",
      caption: ["Recent - Oldest", "Oldest - Recent"],
      value: ["newest", "oldest"],
    };
  }

  //getSortOptionFilters
  static getSortOptionFilters() {
    return {
      default: "lastUpdate",
      caption: ["Last Updated"],
      value: ["lastUpdate"],
    };
  }

  //getSearchProposalFilters on search bar of proposal listing screen
  static getSearchProposalFilters() {
    return {
      default: "proposalNo",
      caption: ["Proposal No", "Customer Name", "Agent ID", "Agent Name", "Company of the Proposed Insured Member"],
      value: ["proposalNo", "customerName", "agentID", "salesRepresentativeName", "company"],
    };
  }

  //getSearchContactFilters on search bar of contact listing screen
  static getSearchContactFilters() {
    return {
      default: "cusName",
      caption: ["Customer Name", "Email Address", "Company of the Proposed Insured Member"],
      value: ["cusName", "email", "company"],
    };
  }

  static getSearchContactQuotationAndProposalFilters() {
    return {
      default: "refNo",
      caption: ["e-Reference/ Proposal No", "Product" /* "New NRIC No.","Old NRIC/Passport No." */],
      value: ["refNo", "product" /* "idNo","otherIdNo" */],
    };
  }

  static getSearchProposalAgentFilters() {
    return this.getJsonContent().proposal.searchProposalAgentFilters;
  }


  static async getMasterDataWithCodeOriginal(param) {
    let list = [];
    let language = LanguageBloc.getSelectedLanguage();
    let resp = await GeneralWebService.getMasterDataWithCode(param);
    if (resp.success) {
      list = resp.data;
    }

    return list;
  }

  static async getJsonConfig() {
    let resp = await GeneralWebService.getScreenConfig();
    if (resp.data) {
      return new DataResult(true, resp.message, resp);
    } else {
      return new DataResult(false, resp.message, null);
    }
  }

  static async getAnnouncements() {
    let resp = await GeneralWebService.getAnnouncements();
    if (resp.data) {
      return new DataResult(true, resp.message, resp);
    } else {
      return new DataResult(false, resp.message, null);
    }
  }

  static async getCampaigns() {
    let resp = await GeneralWebService.getCampaigns();
    if (resp.data) {
      return new DataResult(true, resp.message, resp);
    } else {
      return new DataResult(false, resp.message, null);
    }
  }

  static async getQuickLinks() {
    let resp = await GeneralWebService.getQuickLinks();
    if (resp.data) {
      return new DataResult(true, resp.message, resp);
    } else {
      return new DataResult(false, resp.message, null);
    }
  }

  static async getQuickLinksForms() {
    let resp = await GeneralWebService.getQuickLinksForms();
    if (resp.data) {
      return new DataResult(true, resp.message, resp);
    } else {
      return new DataResult(false, resp.message, null);
    }
  }

  static async getQuickLinksProducts() {
    let resp = await GeneralWebService.getQuickLinksProducts();
    if (resp.data) {
      return new DataResult(true, resp.message, resp);
    } else {
      return new DataResult(false, resp.message, null);
    }
  }

  static getJsonContent() {
    /* let jsonConfig = JSON.parse(sessionStorage.getItem("jsonContent")) || {}    
    if (jsonConfig) {      
      return jsonConfig
    } */
    return jsonData;
  }

  static getSearchQuotationAgentFilters() {
    return this.getJsonContent().quotation.searchFilters;
  }

  static getAdminExampleFiles() {
    return this.getJsonContent().file_upload.example_files;
  }

  static async canByPassOTP(type) {    
    let result = await GeneralWebService.checkOTPByPass(type);
    return result.success === true && result.data === true;
  }

  static previewSkeletor(){
    return <div className="form-content">              
    <Skeleton.Input style={{ width: "800px",height:"60px" }}  active/><br/><br/>
    <Skeleton.Input style={{ width: "800px",height:"60px" }}  active/><br/><br/>
    <Skeleton.Input style={{ width: "800px",height:"60px" }}  active/><br/><br/>
    <Skeleton.Input style={{ width: "800px",height:"60px" }}  active/><br/><br/>
    <Skeleton.Input style={{ width: "800px",height:"60px" }}  active/><br/><br/>
    <Skeleton.Input style={{ width: "800px",height:"60px" }}  active/><br/><br/>
    <Skeleton.Input style={{ width: "800px",height:"60px" }}  active/><br/><br/>
  </div>
  }
}

export default GeneralBloc;
